import { render } from "./ProfileSkeleton.vue?vue&type=template&id=71de2148&scoped=true"
const script = {}

import "./ProfileSkeleton.vue?vue&type=style&index=0&id=71de2148&lang=css"
import "./ProfileSkeleton.vue?vue&type=style&index=1&id=71de2148&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71de2148"]])

export default __exports__